import { hooks, site } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackBlockDuplicated = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_AFTER_BLOCK_DUPLICATED,
    ({ blockId, variationId: blockVariationId }) => {
      if (!blockId) return;

      const isBlockWidget = blockId.startsWith('widget-');
      if (isBlockWidget) return;

      trackEvent(constants.events.BLOCK_DUPLICATED, {
        pageId: site.accessors.getActivePageId(),
        blockId,
        blockVariationId,
      });
    }
  );
};

export default trackBlockDuplicated;
